import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiArrowUp, FiArrowDown, FiFilter } = FiIcons;

const SearchBar = ({
  searchTerm,
  onSearchChange,
  sortBy,
  onSortByChange,
  sortOrder,
  onSortOrderChange
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4">
      <div className="relative flex-1 group">
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
           <SafeIcon icon={FiSearch} size={20} className="text-black" />
        </div>
        <input
          type="text"
          placeholder="Search Database..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="neo-input input-touch pl-10 font-mono text-sm"
        />
      </div>
      
      <div className="flex gap-2">
        <div className="relative flex-1 sm:flex-none">
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
               <SafeIcon icon={FiFilter} size={16} />
            </div>
            <select
              value={sortBy}
              onChange={(e) => onSortByChange(e.target.value)}
              className="neo-input input-touch pl-10 appearance-none cursor-pointer bg-white hover:bg-gray-50 pr-8 w-full sm:w-auto"
            >
              <option value="updated_at">Date Modified</option>
              <option value="created_at">Date Created</option>
              <option value="title">Alphabetical</option>
            </select>
        </div>
        
        <button
          onClick={() => onSortOrderChange(sortOrder === 'asc' ? 'desc' : 'asc')}
          className="min-h-[44px] min-w-[44px] flex-shrink-0 flex items-center justify-center border-2 border-black bg-white shadow-neo hover:bg-gray-50 active:shadow-none active:translate-x-[2px] active:translate-y-[2px] transition-all cursor-pointer"
          title={sortOrder === 'asc' ? 'Ascending' : 'Descending'}
        >
          <SafeIcon
            icon={sortOrder === 'asc' ? FiArrowUp : FiArrowDown}
            size={20}
          />
        </button>
      </div>
    </div>
  );
};

export default SearchBar;
